import { GridRowClassNameParams } from '@mui/x-data-grid-premium'
import { PARENT_TYPES } from 'types'

export const getOrgRowClassNames = (params: GridRowClassNameParams) => {
  const classes: string[] = []

  if (params?.row?.isProduct) classes.push('product-row')
  if (PARENT_TYPES?.has(params?.row?.type)) classes.push('parent-org-row')

  return classes.join(' ')
}
